<template>
    <transition>
        <div v-if="showModal" class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-70 flex justify-center items-center">
            <div class="bg-white border-[1px] rounded-[4px] xl:w-8/12 sm:w-10/12 sm:my-[69px] ">
                <Heading title="Termo de Uso" class="xl:p-10 sm:bg-gray-100 sm:text-primary sm:p-5"/>
                <form @submit.prevent="submit">
                    <div class="mx-2.5 w-2.5/12 xl:px-12 xl:py-10 px-4 py-4 leading-9">
                        <p class="text-[16px] leading-6 sm:text-[14px] xl:pb-11">
                            Houve uma mudança nos nossos termos/regulamento. Para continuar, você precisa ler e aceitar:
                        </p>
                        <div class="flex flex-col overflow-y-scroll hidden-scroll-bar sm:max-h-96 xl:max-h-[42vh] gap-y-8">
                            <TitleDescription class="sm:pt-8" titleClasses="xl:text-4xl sm:text-3xl" descriptionClasses="sm:text-sm xl:text-base" :description="data.text" />
                        </div>

                        <div class="flex mt-6" v-for="(termsAccept, index) in data.termAccepts" :key="index">
                            <input class="hover:bg-gray-600 self-start mt-1 mr-2" type="radio" :id="'acceptTerms-' + index " :name="'acceptTerms-' + index " :value="termsAccept.id" v-model="acceptTerms[index, termsAccept.id]">
                            <label class="text-sm" :for="'acceptTerms-' + index ">{{ termsAccept.text }}</label>
                        </div>

                        <ValidationErrors :errors="errors" />

                        <Button class="py-0 xl:mt-8">
                            Avançar
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    </transition>

</template>

<script>
import Icon from '@/Components/UI/Icons/Icon.vue';
import HeadingGuest from '@/Components/UI/Texts/HeadingGuest.vue';
import Button from '@/Components/Button.vue';
import Heading from '@/Components/UI/Texts/Heading.vue';
import TitleDescription from '@/Components/TitleDescription.vue';
import ValidationErrors from '@/Components/ValidationErrors.vue';

export default {
    components:{
        Icon,
        HeadingGuest,
        Button,
        Heading,
        TitleDescription,
        ValidationErrors,
    },

    props:{
        data: Object,
        showModal: Boolean,
        acceptTerms: {
            type: Object,
            default: {},
        }
    },
    data(){
        return{
            errors: []
        }
    },
    methods: {
        submit() {

            const terms = {
                items: this.acceptTerms
            };

            if (Object.keys(this.acceptTerms).length == 0) {
                this.errors.push('Aceite os termos para prosseguirmos')
                return false;
            }

            this.$inertia.post("/users/accept-term", terms);
        },
    },
}
</script>
<style scoped>
.hidden-scroll-bar::-webkit-scrollbar{
    display: none;
}

</style>
